// extracted by mini-css-extract-plugin
var _1 = "QUYR_moPMy";
var _2 = "skznfaEjkE";
var _3 = "eM6msmMoxa";
var _4 = "LYW3we3_el";
export { _1 as "disabled", _2 as "icon", _3 as "label", _4 as "root" }
